export const BRIDGE_FINDING_CODES = new Set([
  "existing_bridge",
  "bridge_unit",
]);

export function isBridgeFindingCode(code) {
  return BRIDGE_FINDING_CODES.has(String(code || ""));
}

export function isWholeToothSurfaceFillCode(code) {
  return isBridgeFindingCode(code);
}

export function normalizeChartFinding(finding) {
  if (!finding || !isBridgeFindingCode(finding.code)) return finding;
  return {
    ...finding,
    requires_surfaces: false,
    requiresSurfaces: false,
  };
}
